import {FC} from 'react'
import {InputNumber} from '../../InputV2'

type Props = {
  name: string
  textPlaceholder?: string
  disabled?: boolean
  type?: string
  maxLength?: number
  minLength?: number
  required?: boolean
  labelText?: string
}
const InputNumberWrapper: FC<Props> = ({
  name,
  disabled,
  textPlaceholder,
  maxLength,
  minLength,
  required,
  labelText,
  type,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <InputNumber
        type={type}
        name={name}
        textPlaceholder={textPlaceholder}
        disabled={disabled}
        maxLength={maxLength}
        minLength={minLength}
      />
    </div>
  )
}

export default InputNumberWrapper
